import type { FieldPolicy } from "@apollo/client"

export const tenantCacheFields: Record<string, FieldPolicy> = {
  getTenantById: {
    merge: false,
    read(_, { args, toReference, canRead }) {
      if (!args?.id) return
      const ref = toReference({ __typename: "Tenant", Id: args.id })
      if (ref && canRead(ref)) {
        return ref
      }
    },
  },
}
